export default "__VITE_ASSET__BWfzQucD__"